webpackJsonp([11810403067484],{

/***/ 1223:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"CensusPlacementWarning","kind":"ENUM","type":"OBJECT","fields":null,"description":"An advisory reason to confirm before putting a patient into a kennel. None of\nthese block the placement; only a `DO_NOT_USE` kennel is rejected outright.","enumValues":[{"deprecationReason":null,"description":null,"isDeprecated":false,"name":"KENNEL_DIRTY"},{"deprecationReason":null,"description":null,"isDeprecated":false,"name":"KENNEL_OCCUPIED"},{"deprecationReason":null,"description":null,"isDeprecated":false,"name":"OVERLAPPING_RESERVATION"}],"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---enum-census-placement-warning-1dd559c8b4f168f34a50.js